import './axios'
import './fontawesome'
import 'bootstrap'



// WEBPACK FOOTER //
// ./resources/assets/js/plugins/index.js